import get from 'lodash/get';
import map from 'lodash/map';
import invoke from 'lodash/invoke';
import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useRef, useState } from 'react';
import s from './MovieDetail.module.scss';
import {
	STATIC_GENRES,
	STATIC_LANGUAGES,
	LOCAL_SET_ALERT_DATA,
	FROM_AD_BANNER,
	FROM_TRENDING,
} from '../../constants/moviesConst';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import {
	checkH5ScreenName,
	getGenresOrLangListWithUrl,
	getImagesFromCDN,
	getUserLocationPermissionLabel,
} from '../../services/coreUtil';
import LazyLoad from 'react-lazyload';
import cx from 'classnames';
const SetAlert = dynamic(() => import('../SetManageAlert/SetAlert'), { ssr: false });
const MovieHeart = dynamic(() => import('../../components/MovieHeart/MovieHeart'));
const MoviePostersPopUp = dynamic(
	() => import('../../components/MoviePostersPopUpV2/MoviePostersPopUp'),
);
const MovieVideoPlayer = dynamic(
	() => import('../../components/MovieVideoPlayer/MovieVideoPlayer'),
	{ ssr: false },
);
const MovieBlog = dynamic(() => import('../../components/MovieBlog/MovieBlog'));
const MovieVideo = dynamic(() => import('../../components/MovieVideo/MovieVideo'));
const MobileHorizontalLinksWidget = dynamic(
	() => import('../../components/HorizonatalLinksWidget/MobileHorizontalLinksWidget'),
);
const PopularMoviesWidget = dynamic(
	() => import('../../components/PopularMoviesWidget/PopularMoviesWidget'),
);
const UpcomingMoviesWidgetHOC = dynamic(
	() => import('../UpcomingMoviesWidget/UpcomingMoviesWidgetHOC'),
);
const MovieCast = dynamic(() => import('../../components/MovieCast/MovieCast'));
const HorizontalScroll = dynamic(
	() => import('../../components/HorizontalScroll/HorizontalScroll'),
);
import Image from 'next/image';
import { goBack, isH5Container } from '../../services/h5Service';
import { gtmUtils } from '../../services/GTMUtils';
import { useAppSelector } from '../../hooks/hooks';
import { getH5Details } from '../../redux/slices/h5/selectors';
const Breadcrumb = dynamic(() => import('../../components/Breadcrumb/Breadcrumb'));
const FooterQuickLinks = dynamic(
	() => import('../../components/FooterQuickLinks/FooterQuickLinks'),
);
const MobileFooterPadding = dynamic(
	() => import('../../components/MobileFooterPadding/MobileFooterPadding'),
);
import { getCityUrl, getMovieDetailUrl } from '../../services/urlCreator';
import Link from '../../components/Link/Link';
import {
	getCheckedCoordinates,
	getUserCoordinates,
	getUserLocationPermission,
	userSessionDetails,
} from '../../redux/slices/user/selectors';
const AlertSetBanner = dynamic(() => import('../AlertsBanner/AlertSetBanner'));
import mdpAboutImg from '../../../public/assets/images/mdpabout.svg';
import { closeWindow } from '../../h5Utils/h5CoreUtil';
const Footer = dynamic(() => import('paytm-common-components/dist/Footer'));

/*
todo
gtm/pulse events
videos play in native.
download button in image carousel
deeplinks to celeb
open blog links in in app browers
 */

interface Props {
	movieContent: any;
	contentId: string;
	isUpcoming: boolean;
	cityName: string;
	cityLabel: string;
	showLanguageSelector?: boolean;
}

const gaPayload = {
	event_category: 'Movie Tickets - Showtime',
	screenName: checkH5ScreenName('Movie Tickets - Showtime'),
};

const MovieDetail = (props: Props) => {
	const { contentId, movieContent, isUpcoming, cityName, cityLabel, showLanguageSelector } = props;
	const router = useRouter();
	const { platform } = useAppSelector(getH5Details);
	const { query } = router;
	const { frmtid } = query;
	let isReleased = movieContent.isReleased;
	const setAlertLocalData = isH5Container()
		? JSON.parse(window?.localStorage?.getItem(LOCAL_SET_ALERT_DATA) || '{}')
		: {};
	const userDetails = useAppSelector(userSessionDetails);
	const userId = get(userDetails, 'user.info.id', '');
	const setAlertLocalDataUser = setAlertLocalData[userId];
	const [alertPopup, setAlertPopup] = useState('');
	const [alertIsSet, setAlertIsSet] = useState(
		!isReleased && !!userId && !isEmpty(setAlertLocalDataUser)
			? setAlertLocalDataUser[contentId] || false
			: false,
	);
	const userCoordinates = useAppSelector(getUserCoordinates);
	const checkedCoordinates = useAppSelector(getCheckedCoordinates);
	const locationPermission = useAppSelector(getUserLocationPermission);

	if (Number(contentId) === 142580) isReleased = !isUpcoming;
	//const { isH5, userInfo, movieContent } = this.props;
	const { name, summary, videos, images, casts, blogs, languages, genre, languageFormatGroups } =
		movieContent;
	const allLanguages = languageFormatGroups
		?.map((lang) => {
			return lang.lang;
		})
		.join(', ');
	const movieLanguages = invoke([], 'concat', languages).join(', ');
	const movieGenre = genre
		?.map((gen) => {
			return gen;
		})
		.join(', ');
	const [posterState, setPosterState] = useState({ posterIndex: 0, showPosters: false });
	const [videoPlayer, setVideoPlayer] = useState(false);
	const selectedVideo = useRef({});

	const openVideoPlayer = (video) => {
		selectedVideo.current = video;
		setVideoPlayer(true);
	};

	const closePostersPopup = () => {
		setPosterState({
			...posterState,
			showPosters: false,
		});
	};

	const openPostersPopup = (index: number) => {
		setPosterState({ posterIndex: index, showPosters: true });
	};

	const aboutTabGtEvent = (eventAction = 'Upcoming Screen Loaded', eventLabel = '') => {
		gtmUtils.gtmMoviePageEvents({
			...gaPayload,
			...(eventAction === 'Upcoming Screen Loaded' && { event: 'openScreen' }),
			event_action: eventAction,
			event_label: eventLabel || undefined,
			event_label5: cityName,
			event_label6: movieContent?.name,
			event_label7: String(contentId),
			event_label11:
				movieContent?.isReleased && frmtid
					? languageFormatGroups?.find((e) => e.fmtGrpId === frmtid)?.lang
					: movieLanguages,
		});
	};

	const peopleAlsoViewedClickEvent = (movieVal: any, languageVal: any) => {
		gtmUtils.gtmMoviePageEvents({
			...gaPayload,
			event_action: 'People Also Viewed Checked',
			event_label5: cityName,
			event_label6: movieVal?.label,
			event_label7: String(movieVal?.contentId),
			event_label11: languageVal,
		});
	};

	useEffect(() => {
		if (!movieContent?.isReleased) {
			aboutTabGtEvent();
		}
		return () => window.JSBridge?.unsubscribe('back', () => {});
	}, []);

	useEffect(() => {
		if (showLanguageSelector || posterState.showPosters || !!alertPopup) return;
		const url = window.sessionStorage.getItem(FROM_AD_BANNER) ? '' : getCityUrl(cityName);
		const fromTrending = window.sessionStorage.getItem(FROM_TRENDING);
		window.JSBridge?.subscribe('back', () => {
			if (fromTrending) return closeWindow();
			goBack(url);
		});
	}, [cityName, posterState.showPosters, alertPopup, showLanguageSelector]);

	if (!!isEmpty(movieContent)) {
		return (
			<div className="fullPageShimmer" style={{ position: 'relative' }}>
				<Image
					src={mdpAboutImg}
					loader={(src) => src.src}
					alt="Paytm Movies Loading Screen"
					layout="fill"
				/>
			</div>
		);
	}
	const alertBannerClickEvent = () => {
		gtmUtils.gtmMoviePageEvents({
			event_category: 'Movie Tickets - Upcoming Movies',
			screenName: checkH5ScreenName('Movie Tickets - Upcoming Movies'),
			event_action: alertIsSet
				? 'Manage Alerts Button clicked'
				: 'Set Alert Upcoming Movie Clicked',
			event_label: getUserLocationPermissionLabel({
				locationPermission,
				userCoordinates,
				checkedCoordinates,
			}),
			event_label3: 'Source \u003D About movie page',
			event_label5: cityName || null,
			event_label6: movieContent?.name,
			event_label7: String(contentId),
			...(!isEmpty(userCoordinates) && {
				pulse_hc1: `${userCoordinates.latitude}, ${userCoordinates.longitude}`,
			}),
		});
	};

	return (
		<>
			<div className={s.movieContent}>
				{!!posterState.showPosters && (
					<MoviePostersPopUp
						closePostersPopup={closePostersPopup}
						posterState={posterState}
						images={images}
						name={name}
						infiniteScroll={true}
					/>
				)}

				<div className={s.movInfoCon}>
					<h3>Details</h3>
					{!movieContent.isReleased && !!movieLanguages && (
						<div>
							<i className={cx('languageLightIcon', s.languageLightIcon)} />
							<span>{movieLanguages}</span>
						</div>
					)}
					{movieContent.isReleased && !!allLanguages && (
						<div>
							<i className={cx('languageLightIcon', s.languageLightIcon)} />
							<span>{allLanguages}</span>
						</div>
					)}
					{!!movieGenre && (
						<div>
							<i className={cx('genreGrayIcon', s.genreGrayIcon)} />
							<span>{movieGenre}</span>
						</div>
					)}
				</div>

				{platform === 'paytm' && isH5Container() && !isReleased && (
					<div>
						{alertIsSet ? (
							<div className={s.alertSetBannerWrap}>
								<AlertSetBanner
									fromContentId={contentId}
									alertBannerClickEvent={alertBannerClickEvent}
								/>
							</div>
						) : (
							<SetAlert
								contentId={contentId}
								movieName={movieContent.name}
								alertSetSuccess={() => {
									setAlertIsSet(true);
								}}
								setAlertPopupStateOnChange={(setAlertState: string) => {
									setAlertPopup(setAlertState);
									if (setAlertState == 'SET_ALERT') {
										alertBannerClickEvent();
									}
								}}
							/>
						)}
					</div>
				)}

				{!isUpcoming && movieContent.isReleased && (
					<MovieHeart contentId={contentId} movieContent={movieContent} />
				)}

				{!!get(summary, 'summary') && (
					<div className={s.summary}>
						<h3>{get(summary, 'summaryHeader', 'Synopsis')}</h3>
						<p>{get(summary, 'summary', '')}</p>
					</div>
				)}

				{!!get(blogs, 'blogData.length', 0) && (
					<div
						className={cx(s.dealsCon, { [s.noOverflow]: get(blogs, 'blogData.length', 0) === 1 })}
					>
						<h3>{isH5Container() ? 'Deals' : get(blogs, 'blogHeader', 'Blogs')}</h3>
						<HorizontalScroll
							width={get(blogs, 'blogData.length', 0) === 1 ? '100%' : '85%'}
							items={map(blogs.blogData, (blog, index) => (
								<MovieBlog blog={blog} key={`blog_${index}`} />
							))}
						/>
					</div>
				)}

				{!!get(videos, 'videoData.length', 0) && (
					<div
						className={cx(s.videoCon, { [s.noOverflow]: get(videos, 'videoData.length', 0) === 1 })}
					>
						<h3>{get(videos, 'videosHeader', 'Videos')}</h3>
						<HorizontalScroll
							width={get(videos, 'videoData.length', 0) === 1 ? '100%' : '85%'}
							items={map(videos.videoData, (video) => (
								<MovieVideo
									openVideoPlayer={(videoData: any) => {
										openVideoPlayer(videoData);
									}}
									video={video}
									clickEvent={aboutTabGtEvent}
								/>
							))}
						/>
					</div>
				)}

				{!!get(images, 'imageUrls.length', 0) && (
					<div className={s.posterCon}>
						<h2>{get(images, 'imageHeader', 'Posters')}</h2>
						<HorizontalScroll
							width={'180px'}
							items={map(images.imageUrls, (poster, index) => (
								<LazyLoad height={395} offset={400}>
									<img
										src={getImagesFromCDN(poster)}
										key={`poster_${index}`}
										alt={`${movieContent.name} Poster`}
										onClick={(event) => {
											aboutTabGtEvent('Poster click');
											openPostersPopup(index);
										}}
									/>
								</LazyLoad>
							))}
						/>
					</div>
				)}

				{
					/* deep links need to be added for linking to apps.*/
					!!get(casts, 'castData.length', 0) && (
						<div className={s.leadCast}>
							<h2>Cast</h2>
							<HorizontalScroll
								width={'103px'}
								items={map(casts.castData, (cast, index) => (
									<MovieCast cast={cast} key={`cast_${index}`} />
								))}
							/>
						</div>
					)
				}
			</div>
			{!isH5Container() && (
				<>
					<div className={s.popularMoviesWrap}>
						<PopularMoviesWidget
							heading={'People also viewed'}
							currentMovieId={contentId}
							cityName={cityName}
							movieClickEvent={peopleAlsoViewedClickEvent}
						/>
					</div>
					<div className={cx(s.seoContainer)}>
						<UpcomingMoviesWidgetHOC cityName={cityName} cityLabel={cityLabel} />
						<MobileHorizontalLinksWidget
							items={getGenresOrLangListWithUrl(STATIC_GENRES)}
							heading={`Explore Latest Movies in ${cityLabel} by Genre`}
							showHeaderActionLabel={false}
							urlProp="url"
							slidesToScroll={6}
							slidesToShow={6}
							itemHeight="auto"
							labelSuffix="Movies"
							// desktopCarouselStyling
						/>
						<MobileHorizontalLinksWidget
							items={getGenresOrLangListWithUrl(STATIC_LANGUAGES)}
							heading={`Explore Latest Movies in ${cityLabel} by Language`}
							showHeaderActionLabel={false}
							urlProp="url"
							slidesToScroll={6}
							slidesToShow={6}
							itemHeight="auto"
							centerMode={false}
							labelSuffix="Movies"
							// desktopCarouselStyling
						/>
					</div>
					<Footer showScrollTopBtn={false}>
						<Breadcrumb
							ancestors={[
								{
									label: `${movieContent?.name}`,
									url: getMovieDetailUrl(movieContent?.name, contentId),
								},
							]}
						/>
						<FooterQuickLinks />
					</Footer>
				</>
			)}

			{videoPlayer && (
				<MovieVideoPlayer
					video={selectedVideo.current}
					onCloseHandler={() => setVideoPlayer(false)}
					noPadding={true}
					animation={true}
					showCloseButton={true}
					playerWidth={'100%'}
					playerHeight={'100%'}
				/>
			)}
		</>
	);
};

export default MovieDetail;
